import { Component, inject, signal } from '@angular/core';
import { MultiLanguageService } from '../../services/multi-language/multi-language.service';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-footer',
  imports: [
    MatFormFieldModule,
    MatSelectModule,
    FormsModule,
    TranslateModule
  ],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',
})
export class FooterComponent {
  languageService = inject(MultiLanguageService);
  languages = signal<object>({
    en: 'English',
    fr: 'French',
    es: 'Spanish',
    ru: 'Russian',
  });
}
